import { sessionAuthService } from '../services/sessionAuth';

// Get the appropriate API base URL based on environment and device
const getApiBaseUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    // In production, use relative URLs or the production domain
    // This will work for both app.mydew.life and any subdomain
    return '';
  }
  
  // For development, check if we're on mobile or desktop
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  if (isMobile) {
    // Use computer's IP address for mobile testing
    // You may need to update this IP address if it changes
    return 'http://10.0.0.186:3000';
  }
  
  // Use relative URLs for desktop development (webpack proxy will handle routing)
  return '';
};

export const API_BASE_URL = getApiBaseUrl();

// Utility function for making authenticated API requests using session-based auth
export const authenticatedFetch = async (url, options = {}) => {
  try {
    // Use session-based authentication service
    const response = await sessionAuthService.authenticatedRequest(url, options);
    
    if (!response) {
      // Authentication failed and user was redirected to login
      throw new Error('Authentication failed');
    }
    
    return response;
  } catch (error) {
    // Handle network errors separately from auth errors
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      console.error('authenticatedFetch: Network error:', error);
      throw new Error('Network error - please check your connection');
    }
    throw error;
  }
};

// Helper function to make API calls
export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  };

  const response = await fetch(url, {
    ...defaultOptions,
    ...options,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Network error' }));
    throw new Error(error.error || `HTTP error! status: ${response.status}`);
  }

  return response.json();
}; 